import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from 'next/head';

const MobileGrocery = dynamic(() => import('../../components/UAEPages/grocery/MobileGrocery'), {
    loading: () => <Loading />
});

const DesktopGrocery = dynamic(() => import('../../components/UAEPages/grocery/DesktopGrocery'), {
    loading: () => <Loading />
});

const grocery = ({ mobileView }) => {
  return (
    <div>
      <Head>
        <title>Grocery POS Billing Software in UAE | QueueBuster POS</title>
        <meta name="description" content="Manage grocery billing, barcode scanning, inventory, expiry tracking & VAT invoices with QueueBuster Grocery POS Software in UAE. Ideal for baqalas & supermarkets" />
        <link rel="canonical" href="https://queuebuster.co/ae-en/grocery-pos-billing-software-uae" />
        <link rel="alternate" href="https://queuebuster.co/ae-en/grocery-pos-billing-software-uae" hrefLang="en" />
        <meta property="og:title" content="Fast & Reliable Grocery POS Billing Software for UAE Stores"/>
        <meta property="og:description" content="Run your grocery store smarter with QueueBuster POS. Fast billing, barcode scanning, expiry tracking, stock management & VAT-ready invoices for UAE grocery businesses." />
        <meta property="og:image" content="" />
        <meta property="og:url" content="https://queuebuster.co/ae-en/grocery-pos-billing-software-uae" />
      </Head>
      {mobileView ? <MobileGrocery /> : <DesktopGrocery />}
    </div>
  )
}

export default grocery
